import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import users from '../../../../users';

export default {
  name: 'IssueCreditInvoice',
  mixins: [users],
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default,
    EmptyState: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      test: false,
      appId: -1,
      lang: '',
      appData: {
        details: [],
        note: [],
        totalCredit: 0,
        totalDebit: 0
      },
      readOnly: false,

      selectedNoteIndex: -1,
      allowEdit: false,
      deleteConfirmMessage: '',

      currencySymbol: '',

      installmentMethod: 0,
      installmentCharges: 0,
      //details: {
      //  documentTypes: [],
      //  customerKey: '',
      //  customerName: '',
      //  selections: [],
      //  selection: '',
      //  isOwner: false
      //},

      //noteCols: [],
      //note: [],
      //noteKeyColumn: 'sequence',
      //noteTotalCount: 0,
      newTransDialog: false,
      //documentType: '',
      //documentTypesCharges: [],
      //selectedNote: null,
      //selectedNoteEffectiveDate2: null,
      //selectedNoteRDChequeDate2: null,


      //selectedNoteIndex: -1,
      //
      //documentTypesCharges: [],
      effectiveDate2: null,
      rdChequeDate2: null,
      //totalCredit: 0,
      //totalDebit: 0,
      confirmRemoveNote: false,
      editNote: {},
      editDetail: {},
      selectedTransactionType: '',
    }
  },
  computed: {
    displayProperties: function () {
      if (this.appData && this.appData.details && this.appData.details.length > 0
        && this.appData.details[0].properties && this.appData.details[0].properties.length > 0
        && this.selectedNoteIndex >= 0)
        return this.appData.details[this.selectedNoteIndex].properties
      else
        return [];
        
    },
    documentTypes: function () {
      if (this.dataObj && this.dataObj.charges.length > 0
        && this.dataObj.charges[0] && this.dataObj.charges[0].charges && this.dataObj.charges[0].charges.length > 0)
        return this.dataObj.charges[0].charges;
    },
    showCredDorm: function () {
      return this.editNote && this.editNote.sequence && this.editNote.sequence > 0;
    },
    aegings: function () {
      if (this.editDetail && this.editDetail.ageings && this.editDetail.ageings.length > 0)
        return this.editDetail.ageings;
      else
        return [];
    },
  },
  watch: {
    selectedNoteIndex: function (value) {
      if (this.selectedNoteIndex == null || this.selectedNoteIndex < 0)
        return;

      if (this.appData.details[this.selectedNoteIndex].effectiveDate)
        this.effectiveDate2 = moment(this.appData.details[this.selectedNoteIndex].effectiveDate).format('DD/MM/YYYY');

      if (this.appData.details[this.selectedNoteIndex].rdChequeDate)
        this.rdChequeDate2 = moment(this.appData.details[this.selectedNoteIndex].rdChequeDate).format('DD/MM/YYYY');

      if (!this.appData.details[this.selectedNoteIndex].selection && this.appData.details[this.selectedNoteIndex].properties && this.appData.details[this.selectedNoteIndex].properties.lenght > 0)
        this.appData.details[this.selectedNoteIndex].selection = this.appData.details[this.selectedNoteIndex].properties[0].value;

      this.selectedTransactionType = this.appData.details[this.selectedNoteIndex].code + '/' + this.appData.details[this.selectedNoteIndex].subCode;
    },
    selectedTransactionType: function (value) {
      this.appData.details[this.selectedNoteIndex].code = +value.split('/')[0];
      this.appData.details[this.selectedNoteIndex].subCode = +value.split('/')[1];
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('issue_credit_invoice_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        let sett = this.$store.getters.getSettings;
        if (sett) {
          this.currencySymbol = sett.currencySymbol;
        }        

        this.appData.details.forEach(d => d['selection'] = null);

        this.appId = this.dataObj.appId;
        this.readOnly = this.dataObj.readOnly;
        this.appData = this.dataObj.appData;
        this.appData.details.forEach(d => d['selection'] = null);
        this.appData.notes.forEach(n => n['installments'] = []);
        this.selectedNoteIndex = 0;

        if (!this.appData.details[this.selectedNoteIndex].selection
          && this.appData.details[this.selectedNoteIndex].properties
          && this.appData.details[this.selectedNoteIndex].properties.length > 0) {
          this.appData.details[this.selectedNoteIndex].selection = this.appData.details[this.selectedNoteIndex].properties[0].value;
        }
        //console.log(this.selectedNoteIndex);

        this.totalCredit = this.dataObj.appData.totalCredit;
        this.totalDebit = this.dataObj.appData.totalDebit;
        this.allowEdit = true; 

        //for (var i = 0; i < this.appData.details[this.selectedNoteIndex].documentTypes.length; i++) {
        //  var a = {
        //    docType: this.appData.details[this.selectedNoteIndex].documentTypes[i].value,
        //    charges: this.appData.details[this.selectedNoteIndex].documentTypes[i].value == this.appData.details[this.selectedNoteIndex].documentType ? this.appData.details[this.selectedNoteIndex].charges : []
        //  }

        //  this.documentTypesCharges.push(a);
        //}

        //console.log(this.selectedNoteIndex);
        //console.log(this.appData);
      });
    },
    fillData(data) {
      this.appData.details = data.details;
      this.appData.notes = data.notes;
      this.totalCredit = data.totalCredit;
      this.totalDebit = data.totalDebit;
      this.installmentsData = data.installmentsData;
    },
    addNote() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/AddCINote', parameter)
        .then(response => {
          if (response.status == 200) {
            //var maxSeq = response.data.item.notes.reduce((max, p) => p.sequence > max ? p.sequence : max, response.data.item.notes[0].sequence);            

            this.fillData(response.data.item);
            this.loadNote(response.data.item.notes[this.selectedNoteIndex]);
            this.selectedNoteIndex = this.appData.notes.length - 1;

            this.$scrollToElement('details');
          }

        })
        .catch(error => {
          console.log(error)
          this.$alertMsg(error);
        })
        .finally(() => loader.hide());
    },
    fillDocTypeCharges(docType) {
      if (this.selectedNoteIndex <= 0)
        return;

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Sequence: this.selectedNoteIndex,
        DocumentType: this.appData.details[this.selectedNoteIndex].documentType
      };
      axios.post('/IssueDebitCreditNoteActivity/GetNoteCharges', parameter)
        .then(response => {
          if (response.status == 200) {
            this.appData.details[this.selectedNoteIndex].charges = response.data.charges;
            this.appData.details[this.selectedNoteIndex].charge = response.data.charges.length > 0 ? response.data.charges[0].value : '';
            this.documentTypesCharges.filter(a => a.docType == this.appData.details[this.selectedNoteIndex].documentType)[0].charges = response.data.charges;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    modifyNote() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Sequence: this.editNote.sequence,
        InputDetails: {
          DocumentType: this.editDetail.documentType,
          Code: this.editDetail.code,
          SubCode: this.editDetail.subCode,
          IsOwner: this.editDetail.isOwner,
          Ageing: this.editDetail.ageing,
          CustomerKey: this.editDetail.customerKey,
          CustomerName: this.editDetail.customerName,
          EffectiveDate: moment(this.effectiveDate2, "DD/MM/YYYY").add(1, 'days'),
          Amount: this.editDetail.amount,
          DiscountPercentage: this.editDetail.discountPercentage,
          RDChequeDate: this.editDetail.rdChequeVisible == true ? moment(this.rdChequeDate2, "DD/MM/YYYY").add(1, 'days') : null,
          RDChequeNumber: this.editDetail.rdChequeNumber,
          Consumption: this.editDetail.consumptionVisible == true ? this.editDetail.consumption : 0,
          Description: this.editNote.description
        },
        InstallmentsData: {
          TotalAmount: this.editDetail.amount,
          InstallmentMethod: this.editNote.installmentMethod ?? 0,
          InstallmentAmount: this.editNote.installmentAmount,
          NumberOfInstallments: this.editNote.installmentNo,
          InitialAmount: this.editNote.installmentInitPayment,
          ChargeSchedule: this.editNote.installmentCharges ?? 0,
          ChargeMonth: this.editNote.installmentMonth,
          ChargeDay: this.editNote.installmentDay,
          HasInstallments: this.editNote.hasInstallments,
        }
      }
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/ModifyCINote', parameter)
        .then(response => {
          if (response.status == 200) {
            console.log(response.data.item);

            this.appData = response.data.item;

            //this.fillAppData(response.data.item);

            this.editNote = {};
            this.editDetail = {};
            //this.allowEdit = false; 

            loader.hide();
          }
          else {
            loader.hide();
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          loader.hide();
        });
    },
    removeNote() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Sequence: this.appData.notes[this.selectedNoteIndex].sequence
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/RemoveCINote', parameter)
        .then(response => {
          if (response.status == 200) {
            this.selectedNoteIndex = 0;
            this.fillData(response.data.item);
            this.editNote = {};
            this.editDetails = {};

            loader.hide();
          }
          else {
            loader.hide();
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          loader.hide();
        });
    },
    getInstallments() {
      var parameter = {
        DocumentType: this.editDetail.documentType,
        Code: this.editDetail.code,
        SubCode: this.editDetail.subCode,
        IsOwner: this.editDetail.isOwner,
        Ageing: this.editDetail.ageing,
        CustomerKey: this.editDetail.customerKey,
        CustomerName: this.editDetail.customerName,
        EffectiveDate: moment(this.effectiveDate2, "DD/MM/YYYY").add(1, 'days'),
        Amount: this.editDetail.amount,
        DiscountPercentage: this.editDetail.discountPercentage,
        RDChequeDate: this.editDetail.rdChequeVisible == true ? moment(this.rdChequeDate2, "DD/MM/YYYY").add(1, 'days') : null,
        RDChequeNumber: this.editDetail.rdChequeNumber,
        Consumption: this.editDetail.consumptionVisible == true ? this.editDetail.consumption : 0,
        Description: this.editNote.description
      }
        
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueDebitCreditNoteActivity/RefreshInstallments', parameter)
        .then(response => {
          if (response.status == 200) {
            //console.log(response.data);
            this.editNote.installments = response.data;
            //this.editNote.installments = [{ amount: 10, number: 1, chargeDate :'dsd'}]
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
        .finally(() => loader.hide());
    },
    onSelectNote(item) {
      if (item == null)
        return;

      this.selectedNoteIndex = this.dataObj.appData.notes.indexOf(this.dataObj.appData.notes.filter(a => a.sequence == item.sequence)[0]);
      this.loadNote(item);
      //console.log(this.dataObj.appData.notes.indexOf(this.dataObj.appData.notes.filter(a => a.sequence == item.sequence)[0]));
    },
    loadNote(item) {
      this.editNote = { ...item };
      this.editDetail = this.appData.details[this.selectedNoteIndex];

      this.$scrollToElement('details');
      this.getInstallments();
    },
    deleteNote(index) {
      this.selectedNoteIndex = index;

      this.deleteConfirmMessage = 'Are you sure from remove this transaction (' + this.appData.notes[this.selectedNoteIndex].finAppTypeDescription + ' ' + this.appData.notes[this.selectedNoteIndex].typeDescription + ') ?';

      this.confirmRemoveNote = true;
    },
    cancelEdit() {
      this.editNote = {};
      this.editDetail = {};
      //this.allowEdit = false;
    },

    radioChange(val, type) {
      if (type == 'installmentMethod' && val != 0)
        this.editNote.installmentAmount = 0;

      if (type == 'installmentMethod' && val != 1)
        this.editNote.installmentNo = 0;

      if (type == 'installmentCharges' && val != 1) {
        this.editNote.installmentMonth = 0;
        this.editNote.installmentDay = 0;
      }
    },
  },
}
